import { combineReducers } from 'redux';
import { reducer as mainReducer } from './Main/reducer';
import { reducer as loginReducer } from './Login/reducer';
import { reducer as addModalReducer } from './EntriesAddModal/reducer';
import { reducer as landingFlowReducer } from './LandingFlow/reducer';

export const reducer = combineReducers({
	main: mainReducer,
	login: loginReducer,
	addModal: addModalReducer,
	landingFlow: landingFlowReducer
});



// WEBPACK FOOTER //
// ./src/scenes/reducer.js